import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Reveal, { Eyebrow } from "@/components/Reveal";
import { EASE } from "@/components/Reveal";

const items = [
  {
    q: "A certidão circunstanciada é aceita nos consulados?",
    a: "Sim, é o documento reconhecido pelo Itamaraty e pelos consulados para comprovar a situação eleitoral quando o título está irregular ou o cadastro está fechado. A aceitação final, no entanto, depende sempre da análise do consulado específico.",
  },
  {
    q: "O passaporte emitido dessa forma tem validade menor?",
    a: "Em alguns casos sim — durante períodos de cadastro fechado, o consulado pode emitir um passaporte com validade reduzida, condicionado à regularização definitiva depois. Isso é decidido pelo órgão emissor, não por nós, e explicamos esse ponto com clareza antes de você contratar.",
  },
  {
    q: "Preciso quitar multas eleitorais antes?",
    a: "Depende do seu histórico. Fazemos esse levantamento no diagnóstico inicial e te orientamos sobre eventuais pendências financeiras junto à Justiça Eleitoral.",
  },
  {
    q: "Me alistei tarde ou nunca me alistei — ainda dá tempo?",
    a: "Durante o período de cadastro fechado, novos alistamentos ficam suspensos, mas ainda é possível regularizar sua situação para fins de passaporte por outras vias. Fale com a gente para entender qual caminho se aplica ao seu caso.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 md:py-32 border-t border-ink/10" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-[0.8fr_1.2fr] gap-14">
        <Reveal>
          <Eyebrow>Perguntas frequentes</Eyebrow>
          <h2 className="font-serif font-semibold text-4xl md:text-5xl tracking-tight text-ink mt-4">
            O que os clientes mais perguntam.
          </h2>
        </Reveal>

        <div>
          {items.map((item, i) => (
            <Reveal key={item.q} delay={i * 0.06}>
              <div className={`border-ink/12 ${i === 0 ? "border-y" : "border-b"}`}>
                <button
                  data-testid={`faq-question-${i + 1}`}
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-7 text-left group"
                >
                  <span className={`font-serif font-semibold text-[19px] md:text-[21px] transition-colors duration-300 ${open === i ? "text-brass" : "text-ink group-hover:text-brass"}`}>
                    {item.q}
                  </span>
                  <motion.span
                    animate={{ rotate: open === i ? 45 : 0 }}
                    transition={{ duration: 0.25 }}
                    className="font-mono text-xl text-brass shrink-0"
                  >
                    +
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.45, ease: EASE }}
                      className="overflow-hidden"
                    >
                      <p className="text-ink/65 text-[15px] leading-relaxed pb-7 max-w-2xl" data-testid={`faq-answer-${i + 1}`}>
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
